export default __webpack_public_path__ + "static/media/btc.3383c108.png";